import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveArchiveSettingsFailed, saveArchiveSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import loadArchiveSettings from './loadArchiveSettings';

export default function* saveArchiveSettings(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/archive-settings`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(saveArchiveSettingsSuccessful(data));
      yield call(loadArchiveSettings, {});
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(saveArchiveSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(saveArchiveSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
